module.exports = __webpack_public_path__ + "static/media/PTHeadcountPopup.269a346f.png";